/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogOptionsBase,
  CatalogOptionsBaseOptional,
  CatalogOptionsBaseMetaI,
  CatalogOptionsBaseTrackedI,
} from "./catalog-options-base";
import {
  CatalogOptionsBaseTracked,
  CatalogOptionsBaseMeta,
} from "./catalog-options-base";

/**
 *
 * @export
 * @interface CatalogOptionsFull
 */
export interface CatalogOptionsFullOptional extends CatalogOptionsBaseOptional {
  /**
   *
   * @type {number}
   * @memberof CatalogOptionsFull
   */
  displayOrder?: number;
  /**
   * Y/N flag
   * @type {boolean}
   * @memberof CatalogOptionsFull
   */
  active?: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogOptionsFull
   */
  optionName?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogOptionsFull
   */
  optionDisplayName?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogOptionsFull
   */
  optionDescriptionShort?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogOptionsFull
   */
  optionDescriptionLong?: string;
  /**
   *
   * @type {boolean}
   * @memberof CatalogOptionsFull
   */
  availableOnline?: boolean;
}

export interface CatalogOptionsFull
  extends CatalogOptionsFullOptional, CatalogOptionsBase {
  /**
   *
   * @type {number}
   * @memberof CatalogOptionsFull
   */
  displayOrder?: number;
  /**
   * Y/N flag
   * @type {boolean}
   * @memberof CatalogOptionsFull
   */
  active?: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogOptionsFull
   */
  optionName?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogOptionsFull
   */
  optionDisplayName?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogOptionsFull
   */
  optionDescriptionShort?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogOptionsFull
   */
  optionDescriptionLong?: string;
  /**
   *
   * @type {boolean}
   * @memberof CatalogOptionsFull
   */
  availableOnline?: boolean;
}

export interface CatalogOptionsFullTrackedI extends CatalogOptionsBaseOptional {
  /**
   *
   * @type {number}
   * @memberof CatalogOptionsFull
   */
  displayOrder?: number;
  displayOrderIsSet: boolean;
  /**
   * Y/N flag
   * @type {boolean}
   * @memberof CatalogOptionsFull
   */
  active?: boolean;
  activeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogOptionsFull
   */
  optionName?: string;
  optionNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogOptionsFull
   */
  optionDisplayName?: string;
  optionDisplayNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogOptionsFull
   */
  optionDescriptionShort?: string;
  optionDescriptionShortIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogOptionsFull
   */
  optionDescriptionLong?: string;
  optionDescriptionLongIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogOptionsFull
   */
  availableOnline?: boolean;
  availableOnlineIsSet: boolean;
}

transformDatesMap.set(
  "CatalogOptionsFull",
  function (model: CatalogOptionsFull) {},
);

export type CatalogOptionsFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  displayOrder: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  active: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  optionName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  optionDisplayName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  optionDescriptionShort: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  optionDescriptionLong: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  availableOnline: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var CatalogOptionsFullMeta: CatalogOptionsFullMetaI =
  {} as CatalogOptionsFullMetaI;
CatalogOptionsFullMeta = typeMeta("CatalogOptionsFull", {
  displayOrder: propertyMeta(
    "displayOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  active: propertyMeta("active", false, false, false, MetaTypesBase.boolean),
  optionName: propertyMeta(
    "optionName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  optionDisplayName: propertyMeta(
    "optionDisplayName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  optionDescriptionShort: propertyMeta(
    "optionDescriptionShort",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  optionDescriptionLong: propertyMeta(
    "optionDescriptionLong",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  availableOnline: propertyMeta(
    "availableOnline",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = CatalogOptionsFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([CatalogOptionsBaseMeta]);
  metaI.displayOrder.inheritedFrom = CatalogOptionsBaseMeta.displayOrder;
  metaI.active.inheritedFrom = CatalogOptionsBaseMeta.active;
});

export class CatalogOptionsFullTracked
  extends CatalogOptionsBaseTracked
  implements CatalogOptionsFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  displayOrder__I?: number = undefined;
  displayOrderIsSet: boolean = false;
  set displayOrder(v: undefined | number) {
    if (v !== undefined) {
      this.displayOrder__I = v;
      this.displayOrderIsSet = true;
    } else {
      this.displayOrder__I = v || undefined;
      this.displayOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get displayOrder() {
    return this.displayOrder__I;
  }
  active__I?: boolean = undefined;
  activeIsSet: boolean = false;
  set active(v: undefined | boolean) {
    if (v !== undefined) {
      this.active__I = v;
      this.activeIsSet = true;
    } else {
      this.active__I = v || undefined;
      this.activeIsSet = false;
    }
    this.changeTracker = true;
  }
  get active() {
    return this.active__I;
  }
  optionName__I?: string = undefined;
  optionNameIsSet: boolean = false;
  set optionName(v: undefined | string) {
    if (v !== undefined) {
      this.optionName__I = v;
      this.optionNameIsSet = true;
    } else {
      this.optionName__I = v || undefined;
      this.optionNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get optionName() {
    return this.optionName__I;
  }
  optionDisplayName__I?: string = undefined;
  optionDisplayNameIsSet: boolean = false;
  set optionDisplayName(v: undefined | string) {
    if (v !== undefined) {
      this.optionDisplayName__I = v;
      this.optionDisplayNameIsSet = true;
    } else {
      this.optionDisplayName__I = v || undefined;
      this.optionDisplayNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get optionDisplayName() {
    return this.optionDisplayName__I;
  }
  optionDescriptionShort__I?: string = undefined;
  optionDescriptionShortIsSet: boolean = false;
  set optionDescriptionShort(v: undefined | string) {
    if (v !== undefined) {
      this.optionDescriptionShort__I = v;
      this.optionDescriptionShortIsSet = true;
    } else {
      this.optionDescriptionShort__I = v || undefined;
      this.optionDescriptionShortIsSet = false;
    }
    this.changeTracker = true;
  }
  get optionDescriptionShort() {
    return this.optionDescriptionShort__I;
  }
  optionDescriptionLong__I?: string = undefined;
  optionDescriptionLongIsSet: boolean = false;
  set optionDescriptionLong(v: undefined | string) {
    if (v !== undefined) {
      this.optionDescriptionLong__I = v;
      this.optionDescriptionLongIsSet = true;
    } else {
      this.optionDescriptionLong__I = v || undefined;
      this.optionDescriptionLongIsSet = false;
    }
    this.changeTracker = true;
  }
  get optionDescriptionLong() {
    return this.optionDescriptionLong__I;
  }
  availableOnline__I?: boolean = undefined;
  availableOnlineIsSet: boolean = false;
  set availableOnline(v: undefined | boolean) {
    if (v !== undefined) {
      this.availableOnline__I = v;
      this.availableOnlineIsSet = true;
    } else {
      this.availableOnline__I = v || undefined;
      this.availableOnlineIsSet = false;
    }
    this.changeTracker = true;
  }
  get availableOnline() {
    return this.availableOnline__I;
  }
  constructor(config?: CatalogOptionsFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: CatalogOptionsFullOptional,
    options?: AssignOptions,
  ): CatalogOptionsFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.displayOrder &&
      this.displayOrderApplyFilter(optionsRequired.filter)
    ) {
      this.displayOrder = config.displayOrder;
      if (optionsRequired.unassign) this.displayOrderIsSet = false;
      else this.displayOrderIsSet = true;
    }
    if (config.active && this.activeApplyFilter(optionsRequired.filter)) {
      this.active = config.active;
      if (optionsRequired.unassign) this.activeIsSet = false;
      else this.activeIsSet = true;
    }
    if (
      config.optionName &&
      this.optionNameApplyFilter(optionsRequired.filter)
    ) {
      this.optionName = config.optionName;
      if (optionsRequired.unassign) this.optionNameIsSet = false;
      else this.optionNameIsSet = true;
    }
    if (
      config.optionDisplayName &&
      this.optionDisplayNameApplyFilter(optionsRequired.filter)
    ) {
      this.optionDisplayName = config.optionDisplayName;
      if (optionsRequired.unassign) this.optionDisplayNameIsSet = false;
      else this.optionDisplayNameIsSet = true;
    }
    if (
      config.optionDescriptionShort &&
      this.optionDescriptionShortApplyFilter(optionsRequired.filter)
    ) {
      this.optionDescriptionShort = config.optionDescriptionShort;
      if (optionsRequired.unassign) this.optionDescriptionShortIsSet = false;
      else this.optionDescriptionShortIsSet = true;
    }
    if (
      config.optionDescriptionLong &&
      this.optionDescriptionLongApplyFilter(optionsRequired.filter)
    ) {
      this.optionDescriptionLong = config.optionDescriptionLong;
      if (optionsRequired.unassign) this.optionDescriptionLongIsSet = false;
      else this.optionDescriptionLongIsSet = true;
    }
    if (
      config.availableOnline &&
      this.availableOnlineApplyFilter(optionsRequired.filter)
    ) {
      this.availableOnline = config.availableOnline;
      if (optionsRequired.unassign) this.availableOnlineIsSet = false;
      else this.availableOnlineIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CatalogOptionsFullTrackedI {
    const cloned = {} as CatalogOptionsFullTrackedI;
    if (
      this.displayOrderIsSetDeep() &&
      this.displayOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.displayOrderIsSet = true;
      cloned.displayOrder = this.displayOrder;
    } else {
      //cloned.displayOrderIsSet = false
    }
    if (
      this.activeIsSetDeep() &&
      this.activeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.activeIsSet = true;
      cloned.active = this.active;
    } else {
      //cloned.activeIsSet = false
    }
    if (
      this.optionNameIsSetDeep() &&
      this.optionNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.optionNameIsSet = true;
      cloned.optionName = this.optionName;
    } else {
      //cloned.optionNameIsSet = false
    }
    if (
      this.optionDisplayNameIsSetDeep() &&
      this.optionDisplayNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.optionDisplayNameIsSet = true;
      cloned.optionDisplayName = this.optionDisplayName;
    } else {
      //cloned.optionDisplayNameIsSet = false
    }
    if (
      this.optionDescriptionShortIsSetDeep() &&
      this.optionDescriptionShortApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.optionDescriptionShortIsSet = true;
      cloned.optionDescriptionShort = this.optionDescriptionShort;
    } else {
      //cloned.optionDescriptionShortIsSet = false
    }
    if (
      this.optionDescriptionLongIsSetDeep() &&
      this.optionDescriptionLongApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.optionDescriptionLongIsSet = true;
      cloned.optionDescriptionLong = this.optionDescriptionLong;
    } else {
      //cloned.optionDescriptionLongIsSet = false
    }
    if (
      this.availableOnlineIsSetDeep() &&
      this.availableOnlineApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.availableOnlineIsSet = true;
      cloned.availableOnline = this.availableOnline;
    } else {
      //cloned.availableOnlineIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CatalogOptionsFullTrackedI {
    if (!this.displayOrderApplyFilter(filter)) this.displayOrderIsSet = false;

    if (!this.activeApplyFilter(filter)) this.activeIsSet = false;

    if (!this.optionNameApplyFilter(filter)) this.optionNameIsSet = false;

    if (!this.optionDisplayNameApplyFilter(filter))
      this.optionDisplayNameIsSet = false;

    if (!this.optionDescriptionShortApplyFilter(filter))
      this.optionDescriptionShortIsSet = false;

    if (!this.optionDescriptionLongApplyFilter(filter))
      this.optionDescriptionLongIsSet = false;

    if (!this.availableOnlineApplyFilter(filter))
      this.availableOnlineIsSet = false;

    return this;
  }
  displayOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogOptionsFullMeta.displayOrder,
      CatalogOptionsFullMeta,
      this.displayOrder,
      this,
    );
  }
  displayOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.displayOrderIsSet && this.displayOrderApplyFilter(filter))
      return true;

    return false;
  }
  activeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogOptionsFullMeta.active,
      CatalogOptionsFullMeta,
      this.active,
      this,
    );
  }
  activeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.activeIsSet && this.activeApplyFilter(filter)) return true;

    return false;
  }
  optionNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogOptionsFullMeta.optionName,
      CatalogOptionsFullMeta,
      this.optionName,
      this,
    );
  }
  optionNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.optionNameIsSet && this.optionNameApplyFilter(filter)) return true;

    return false;
  }
  optionDisplayNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogOptionsFullMeta.optionDisplayName,
      CatalogOptionsFullMeta,
      this.optionDisplayName,
      this,
    );
  }
  optionDisplayNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.optionDisplayNameIsSet &&
      this.optionDisplayNameApplyFilter(filter)
    )
      return true;

    return false;
  }
  optionDescriptionShortApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogOptionsFullMeta.optionDescriptionShort,
      CatalogOptionsFullMeta,
      this.optionDescriptionShort,
      this,
    );
  }
  optionDescriptionShortIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.optionDescriptionShortIsSet &&
      this.optionDescriptionShortApplyFilter(filter)
    )
      return true;

    return false;
  }
  optionDescriptionLongApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogOptionsFullMeta.optionDescriptionLong,
      CatalogOptionsFullMeta,
      this.optionDescriptionLong,
      this,
    );
  }
  optionDescriptionLongIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.optionDescriptionLongIsSet &&
      this.optionDescriptionLongApplyFilter(filter)
    )
      return true;

    return false;
  }
  availableOnlineApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogOptionsFullMeta.availableOnline,
      CatalogOptionsFullMeta,
      this.availableOnline,
      this,
    );
  }
  availableOnlineIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.availableOnlineIsSet && this.availableOnlineApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.displayOrderIsSetDeep(filter)) return true;
    if (this.activeIsSetDeep(filter)) return true;
    if (this.optionNameIsSetDeep(filter)) return true;
    if (this.optionDisplayNameIsSetDeep(filter)) return true;
    if (this.optionDescriptionShortIsSetDeep(filter)) return true;
    if (this.optionDescriptionLongIsSetDeep(filter)) return true;
    if (this.availableOnlineIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
